import { ThemeOptions } from '@mui/material'
import { PaletteOptions } from '@mui/material/styles/createPalette'

export default function palette(theme: ThemeOptions) {
  const palette: PaletteOptions = {
    common: {
      black: theme.colors.shade100,
      white: theme.colors.shade0,
    },
    primary: {
      main: theme.colors.primary500,
      light: theme.colors.primary200,
      dark: theme.colors.primary800,
      contrastText: theme.colors.shade0,
    },
    secondary: {
      main: theme.colors.secondary500,
      light: theme.colors.secondary300,
      dark: theme.colors.secondary700,
      contrastText: theme.colors.shade100,
    },
    tertiary: {
      main: theme.colors.shade0,
      light: theme.colors.shade0,
      dark: theme.colors.grey50,
      contrastText: theme.colors.shade100,
    },
    subtle: {
      main: theme.colors.primary100,
      light: theme.colors.primary100,
      dark: theme.colors.primary700,
      contrastText: theme.colors.primary700,
    },
    greyed: {
      main: theme.colors.grey500,
      light: theme.colors.grey300,
      dark: theme.colors.grey700,
      contrastText: theme.colors.shade0,
    },
    error: {
      main: theme.colors.error600,
      light: theme.colors.error400,
      dark: theme.colors.error800,
    },
    warning: {
      main: theme.colors.secondary500,
      light: theme.colors.secondary300,
      dark: theme.colors.secondary700,
    },
    success: {
      main: theme.colors.primary500,
      light: theme.colors.primary200,
      dark: theme.colors.primary800,
    },
    info: {
      main: theme.colors.info500,
      light: theme.colors.primary200,
      dark: theme.colors.primary800,
    },
    grey: {
      50: theme.colors.grey50,
      100: theme.colors.grey100,
      200: theme.colors.grey200,
      300: theme.colors.grey300,
      400: theme.colors.grey400,
      500: theme.colors.grey500,
      600: theme.colors.grey600,
      700: theme.colors.grey700,
      800: theme.colors.grey800,
      900: theme.colors.grey900,
    },
    background: {
      paper: theme.colors.shade0,
      default: theme.colors.primary25,
    },
    contrastThreshold: 4.5,
  }

  return palette
}
